/**
 * Calendar MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import { CALENDAR_QUERY_KEY, fetchCalendarMonthFromApi } from "./calendarQueryApi";

export const calendarQueryClient = makeMv2QueryClient();
setupMv2CachePersist(calendarQueryClient, "calendar");

export function prefetchCalendar() {
  const now = new Date();
  return calendarQueryClient.prefetchQuery({
    queryKey: [CALENDAR_QUERY_KEY, now.getFullYear(), now.getMonth()],
    queryFn: ({ signal }) =>
      fetchCalendarMonthFromApi(now.getFullYear(), now.getMonth(), signal),
  });
}
